import { VIPPS_PAYMENT_STATUS_PIPELINE } from "../constants.js";
export const getVippsPaymentStage = (pipelines) => {
    const vippsPipeline = pipelines?.find(({ pipeline }) => pipeline.name === VIPPS_PAYMENT_STATUS_PIPELINE.NAME);
    if (!vippsPipeline)
        return;
    return vippsPipeline.pipeline.stages?.find((stage) => stage.id === vippsPipeline.stageId)?.name;
};
